import { render, staticRenderFns } from "./JargonDialog.vue?vue&type=template&id=79e50197&scoped=true"
import script from "./JargonDialog.vue?vue&type=script&lang=js"
export * from "./JargonDialog.vue?vue&type=script&lang=js"
import style0 from "./JargonDialog.vue?vue&type=style&index=0&id=79e50197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e50197",
  null
  
)

export default component.exports